"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavouriteAdded = void 0;
const wishlist_event_1 = require("./wishlist-event");
class FavouriteAdded extends wishlist_event_1.WishlistEvent {
    constructor(userId, studyId, eventId, stateHash, dateAdded, isLocal) {
        super(dateAdded);
        this.userId = userId;
        this.studyId = studyId;
        this.eventId = eventId;
        this.stateHash = stateHash;
        this.dateAdded = dateAdded;
        this.isLocal = isLocal;
        this.eventType = FavouriteAdded.EventType;
        this.eventVersion = '1.0.0';
    }
    static create(userId, studyId, stateHash, dateAdded = new Date(), isLocal) {
        return new FavouriteAdded(userId, studyId, wishlist_event_1.WishlistEvent.generateId(), stateHash, dateAdded, isLocal);
    }
}
exports.FavouriteAdded = FavouriteAdded;
FavouriteAdded.EventType = 'FavouriteAdded';
